export const shop_body = [
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw25752e22/crop/026480505_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    id: "1",
    name: "Poppy",
    category1: "Fine Fragrance Mist",
    Amount: "17.50",
    Rating: "23",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw9f862ce9/crop/026499650_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "2",
    name: "Blueberry Sugar Pancakes",
    category1: "Shower Gel",
    Amount: "13.50",
    Rating: "5",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwbdf5ccfe/crop/026498930_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "3",
    name: "Pinkberry Clouds",
    category1: "Ultimate Hydration Body Cream",
    Amount: "16.50",
    Rating: "3",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw5fc327ba/crop/026494220_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "4",
    name: "Wicked Vanilla Woods",
    category1: "Fine Fragrance Mist",
    Amount: "16.50",
    Rating: "4",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw647fdf84/crop/026487463_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "5",
    name: "Marshmallow Pumpkin Latte",
    category1: "Shower Gel",
    Amount: "13.50",
    Rating: "2",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw3c8cf0df/crop/026487468_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New",
    id: "6",
    name: "Champagne Apple & Honey",
    category1: "Ultimate Hydration Body Cream",
    Amount: "16.50",
    Rating: "5",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwe9b129f1/crop/026495794_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Online Exclusive",
    id: "7",
    name: "White Jashmine",
    category1: "Shower Gel",
    Amount: "13.50",
    Rating: "46",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw22c9610c/crop/026494225_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    id: "8",
    name: "Enchanted Candy Potion",
    category1: "Ultimate Hydration Body Cream",
    Amount: "16.50",
    Rating: "8",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw3d7b64eb/crop/026490260_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "Online Exclusive",
    id: "9",
    name: "Pumpkin Cupcake",
    category1: "Fine Fragrance Mist",
    Amount: "16.50",
    Rating: "3",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwc0c14c75/crop/026353220_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: " ",
    id: "10",
    name: "Eucalyptus Spearmint",
    category1: "Ultimate Hydration Body Cream",
    Amount: "16.50",
    Rating: "262",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwfc00ff1b/crop/026502463_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "11",
    name: "Into the Night",
    category1: "Daily Nourishing Body Lotion",
    Amount: "14.50",
    Rating: "150",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwba77ffbc/crop/026267868_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "",
    id: "12",
    name: "Ocean",
    category1: "Body Spray",
    Amount: "13.50",
    Rating: "264",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw33ebb892/crop/026494224_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "13",
    name: "Wicked Vanilla Woods",
    category1: "Ultimate Hydration Body Cream",
    Amount: "16.50",
    Rating: "4",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw3086cd09/crop/026487476_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "14",
    name: "Champagne Apple & Honey",
    category1: "Fine Fragrance Mist",
    Amount: "16.50",
    Rating: "14",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw3afb5b61/crop/026498943_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "15",
    name: "Sun-Washed Citrus",
    category1: "Shower Gel",
    Amount: "13.50",
    Rating: "15",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwa447a07d/crop/026470654_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    id: "16",
    name: "Poppy",
    category1: "Mini Perfume Spray",
    Amount: "13.50",
    Rating: "5",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dweef4e778/crop/026498944_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New",
    id: "17",
    name: "Denim & Daisies",
    category1: "Shower Gel",
    Amount: "13.50",
    Rating: "3",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw112bd7db/crop/026480507_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    id: "18",
    name: "Poppy",
    category1: "Ultimate Hydration Body Cream",
    Amount: "17.50",
    Rating: "1",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwdc6fe860/crop/026494221_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    id: "19",
    name: "Poppy",
    category1: "Enchanted Candy Potion",
    Amount: "16.50",
    Rating: "17",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
  {
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw2fb38c84/crop/026502529_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    id: "20",
    name: "A Thousand Wishes",
    category1: "Shower Gel",
    Amount: "13.50",
    Rating: "197",
    desc: "Mix & Math Full-Size: Buy 3, Get 3 Free or Buy 2, Get 1 Free",
  },
];
